import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { GetProjectNamesRequest, IGetProjectNamesResult } from '../../ts/ServerApi/requests/GetProjectNamesRequest';
import { IProjectName } from '../../ts/ServerApi/types/IProject';
import { IDetailResource, IListResource } from '../../ts/resources/Resource';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { NamedItemKeys } from '../../ts/ServerApi/types/resourceParts';
import { Filter } from '../../ts/helpers/Filter';
import { ILeafFilterClause } from '../../ts/ServerApi/types/IFilterClause';

class ProjectNamesResource implements IListResource<IProjectName>, IDetailResource<IProjectName> {

  private listFetcher: IListFetcher<IProjectName> = new WebClientListResourceFetcher(
    GetProjectNamesRequest,
    (result: IGetProjectNamesResult) => result.projects);

  public all(): ResourceQuery<IProjectName> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string, additionalFilterClauses?: ILeafFilterClause[]): Promise<IProjectName> {
    return toNativePromise(
      this.all()
        .withFilters(additionalFilterClauses ?? [])
        .addFilter(Filter.stringFieldEq(NamedItemKeys.id, id))
        .getFirst()
    );
  }
}

export const ProjectNames = new ProjectNamesResource;
